/* eslint-disable no-underscore-dangle */
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import * as Sentry from '@sentry/browser';
import SentryConfig from './sentryconfig';
import createEmotionCache from './server/createEmotionCache';
import ServerApp from './server/ServerApp';
const environment = process.env.NODE_ENV === 'production'
    ? 'Frontend-ReactJS-Production'
    : 'Frontend-ReactJS-Development';
Sentry.init(SentryConfig(environment));
const Application = () => {
    const cache = createEmotionCache();
    const data = {
        navigation: window.__NAVIGATION_DATA__,
        commonData: window.__COMMON_DATA__,
        apiData: window.__API_DATA__ || null,
    };
    const searchURL = new URLSearchParams(window.location.search);
    const queryParams = Object.fromEntries(searchURL);
    return (React.createElement(ServerApp, { data: data, cache: cache, location: window.location.pathname, queryParams: queryParams }));
};
const container = document.getElementById('app');
// Create root and hydrate
hydrateRoot(container, React.createElement(Application, null));
